import React, { useState } from 'react';

import { FormattedMessage } from '../../../util/reactIntl';
import { Modal, ShareLinks } from '../../../components';

import css from './ClassDetail.module.css';

const IconCopy = () => (
  <svg className={css.copyIcon} viewBox="0 0 24 24" role="none">
    <rect x="9" y="9" width="12" height="12" rx="2" fill="none" strokeWidth="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" fill="none" strokeWidth="2" />
  </svg>
);

// How long the "Copied!" confirmation shows.
const COPIED_RESET_MS = 2000;

/**
 * "Share this activity with other parents" (Figma) -- a copy-link row plus the existing
 * device-native ShareLinks (Text/Email with a prefilled message). The mockup's server-sent email
 * invitation is intentionally NOT built (no email-sending backend for it; flagged to the client) --
 * the Email link opens the parent's own mail app prefilled instead.
 */
const ClassShareModal = props => {
  const { isOpen, onClose, listingTitle, listingUrl, onManageDisableScrolling } = props;
  const [copied, setCopied] = useState(false);

  const onCopy = () => {
    const markCopied = () => {
      setCopied(true);
      window.setTimeout(() => setCopied(false), COPIED_RESET_MS);
    };
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(listingUrl).then(markCopied, () => {});
    } else {
      // Legacy fallback: select-and-copy from the readonly input.
      const input = document.getElementById('ClassDetail.shareUrl');
      if (input) {
        input.select();
        document.execCommand('copy');
        markCopied();
      }
    }
  };

  return (
    <Modal
      id="ClassDetail.share"
      containerClassName={css.shareModalContainer}
      isOpen={isOpen}
      onClose={onClose}
      usePortal
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <h2 className={css.shareModalTitle}>
        <FormattedMessage id="ClassDetailPage.shareModalTitle" />
      </h2>
      <p className={css.shareModalSubtitle}>
        <FormattedMessage id="ClassDetailPage.shareModalSubtitle" />
      </p>

      <label className={css.shareLinkLabel} htmlFor="ClassDetail.shareUrl">
        <FormattedMessage id="ClassDetailPage.shareViaLink" />
      </label>
      <div className={css.shareLinkRow}>
        <input
          id="ClassDetail.shareUrl"
          className={css.shareLinkInput}
          type="text"
          readOnly
          value={listingUrl}
          onFocus={e => e.target.select()}
        />
        <button type="button" className={css.copyButton} onClick={onCopy}>
          <IconCopy />
          <FormattedMessage
            id={copied ? 'ClassDetailPage.linkCopied' : 'ClassDetailPage.copyLink'}
          />
        </button>
      </div>

      <ShareLinks
        className={css.shareModalNativeLinks}
        listingTitle={listingTitle}
        listingUrl={listingUrl}
      />
    </Modal>
  );
};

export default ClassShareModal;
